import unauthAxios, { unauthAxiosFetcher } from "../axios";
import authAxios, { authAxiosFetcher } from "../authAxios";
import useSWR from "swr";

export const uploadBlobToS3 = async (blob) => {
  let formData = new FormData();
  formData.append("media", blob);

  const result = await unauthAxios.post("/v1/upload/aws", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return result.data.url;
};

export const uploadBigFileToS3 = async (file) => {
  const s3Key = new Date().toISOString() + file.name;
  const options = {
    headers: {
      "Content-Type": file.type,
    },
  };

  const res = await unauthAxios.get("/v1/upload/getSignedUrl", {
    params: { key: s3Key, file_type: file.type },
  });

  const { signedUploadUrl, resourceUrl } = res.data;

  await unauthAxios
    .put(signedUploadUrl, file, options)
    .then((_response) => {})
    .catch((err) => {
      console.log(err);
      alert("Upload Failed");
    });

  return resourceUrl;
};
